export function useFormRow(children, mode, key) {
    let rootSx = defaultLayoutRootSx;
    let childrenSx = defaultLayoutChildrenSx;
    if (mode === 'review') {
        rootSx = {};
        childrenSx = [{ pb: 2 }];
    }
    return {
        type: 'alert.customLayout',
        key: key !== null && key !== void 0 ? key : '!customLayout',
        rootSx,
        childrenSx,
        children,
    };
}
export const defaultLayoutRootSx = {
    display: {
        xl: 'flex',
        lg: 'flex',
        md: 'flex',
    },
    justifyContent: {
        xl: 'space-between',
        lg: 'space-between',
        md: 'space-between',
    },
};
export const defaultLayoutChildrenSx = [
    {
        width: {
            xl: '32%',
            lg: '38%',
            md: '34%',
        },
        ml: 1,
        mt: {
            xl: 0.3,
            lg: 0.3,
            md: 1,
        },
        pb: {
            xl: 0,
            lg: 0,
            md: 0,
            sm: 2,
            xs: 2,
        },
    },
    {
        width: {
            xl: '64%',
            lg: '57%',
            md: '59%',
        },
    },
];
